


import { Button } from "@progress/kendo-react-buttons";
import { useTranslation } from "react-i18next";

interface GxSecondaryButtonProps {
  onResendClick?: () => void;
  label?: string;
   disabled?: boolean;
}
const GxResendButton: React.FC<GxSecondaryButtonProps> = ({
  onResendClick,
  label ="",
   disabled = false, 
}) => {
  const { t } = useTranslation();
  return (
    <Button
      type="button"
      onClick={onResendClick}
      className="gx-dialog-back-button gx-p14-sb"
      disabled={disabled} 
    >
      <span className="gx-p14-sb">{t(label)}</span> 
    </Button>
  );
};

export default GxResendButton;
